import { Component, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { RecipeLite } from '../../../../../../../../shared/models/recipe/recipe-lite.model';
import { ResourceMediaLite } from '../../../../../../../../shared/models/generic/media/resource-media-lite.model';
import { Utils } from '../../../../../../../../shared/utils/utils';

@Component({
  selector: 'app-media-selector-inputs',
  templateUrl: './media-selector-inputs.component.html',
  styleUrls: ['./media-selector-inputs.component.scss'],
  standalone: false,
})
export class MediaSelectorInputsComponent {
  @Input() variant?: RecipeLite | null;
  @Input() formArray?: UntypedFormArray;
  @Input() formVariant?: UntypedFormGroup;
  @Input() formArrayIndex?: number;
  @Input() imgPlaceHolderWidth = 50;
  @Input() imgPlaceHolderHeight = 50;

  constructor() {}

  selectedMedia(mediaIdentifier: string | undefined): void {
    if (typeof this.formArrayIndex === 'number') {
      const step = this.formArray?.controls[this.formArrayIndex].value;
      if (mediaIdentifier) {
        step.resourceMedias = [mediaIdentifier];
      } else {
        step.resourceMedias = [];
      }
      this.formArray?.controls[this.formArrayIndex].setValue(step);
      this.formArray?.markAsDirty();

      const variantStep = this.formVariant?.controls.steps.value;
      variantStep[this.formArrayIndex].resourceMedias = step.resourceMedias;
      this.formVariant?.controls.steps.setValue(variantStep);
      this.formVariant?.markAsDirty();
    }
  }

  getMedia(): ResourceMediaLite | undefined {
    let mediaFined;
    if (typeof this.formArrayIndex === 'number') {
      const media = this.formArray?.controls[this.formArrayIndex].value.resourceMedias;
      if (media) {
        mediaFined = this.variant?.resourceMedias?.find((resourceMedia) => resourceMedia?.identifier === media[0]);
      }
    }
    return mediaFined;
  }

  isYoutubeVideo(url: string = ''): boolean {
    return Utils.isYoutubeVideo(url);
  }

  transformForYoutube(url: string = ''): string {
    return Utils.transformUrlForYoutube(url);
  }
}
